export default [
    {
        path: '/pages/common/storeInfoManage',
        name: '/pages/common/storeInfoManage',
        component: () => import('@/views/common/storeInfoManage.vue')
    },
    // {
    //     path: '/pages/common/resourceStoreManage',
    //     name: '/pages/common/resourceStoreManage',
    //     component: () => import('@/views/common/resourceStoreManage.vue')
    // },
    // {
    //     path: '/pages/common/resourceOutManage',
    //     name: '/pages/common/resourceOutManage',
    //     component: () => import('@/views/common/resourceOutManage.vue')
    // },
    // {
    //     path: '/pages/common/resourceEnterManage',
    //     name: '/pages/common/resourceEnterManage',
    //     component: () => import('@/views/common/resourceEnterManage.vue')
    // },
    // {
    //     path: '/pages/common/resourceEnterDetailManage',
    //     name: '/pages/common/resourceEnterDetailManage',
    //     component: () => import('@/views/common/resourceEnterDetailManage.vue')
    // },
    // {
    //     path: '/pages/common/purchaseApplyManage',
    //     name: '/pages/common/purchaseApplyManage',
    //     component: () => import('@/views/common/purchaseApplyManage.vue')
    // },
    // {
    //     path: '/pages/common/purchaseApplyDetail',
    //     name: '/pages/common/purchaseApplyDetail',
    //     component: () => import('@/views/common/purchaseApplyDetail.vue')
    // },
    // {
    //     path: '/pages/common/orgCommunityManage',
    //     name: '/pages/common/orgCommunityManage',
    //     component: () => import('@/views/common/orgCommunityManage.vue')
    // },
    // {
    //     path: '/pages/common/noticeManage',
    //     name: '/pages/common/noticeManage',
    //     component: () => import('@/views/common/noticeManage.vue')
    // },
    // {
    //     path: '/pages/common/noticeDetail',
    //     name: '/pages/common/noticeDetail',
    //     component: () => import('@/views/common/noticeDetail.vue')
    // },
    // {
    //     path: '/pages/common/myAuditHistoryComplaints',
    //     name: '/pages/common/myAuditHistoryComplaints',
    //     component: () => import('@/views/common/myAuditHistoryComplaints.vue')
    // },
    // {
    //     path: '/pages/common/myAuditComplaints',
    //     name: '/pages/common/myAuditComplaints',
    //     component: () => import('@/views/common/myAuditComplaints.vue')
    // },
    // {
    //     path: '/pages/common/itemOutManage',
    //     name: '/pages/common/itemOutManage',
    //     component: () => import('@/views/common/itemOutManage.vue')
    // },
    // {
    //     path: '/pages/common/itemInManage',
    //     name: '/pages/common/itemInManage',
    //     component: () => import('@/views/common/itemInManage.vue')
    // },
    {
        path: '/pages/common/enterCommunity',
        name: '/pages/common/enterCommunity',
        component: () => import('@/views/common/enterCommunity.vue')
    },
    // {
    //     path: '/pages/common/complaintManage',
    //     name: '/pages/common/complaintManage',
    //     component: () => import('@/views/common/complaintManage.vue')
    // },
    {
        path: '/pages/common/Company',
        name: '/pages/common/Company',
        component: () => import('@/views/common/Company.vue')
    },
    {
        path: '/pages/common/communityManage',
        name: '/pages/common/communityManage',
        component: () => import('@/views/common/communityManage.vue')
    },
    {
        path: '/pages/common/auditUserManage',
        name: '/pages/common/auditUserManage',
        component: () => import('@/views/common/auditUserManage.vue')
    },
    {
        path: '/pages/common/auditEnterCommunityManage',
        name: '/pages/common/auditEnterCommunityManage',
        component: () => import('@/views/common/auditEnterCommunityManage.vue')
    },
    {
        path: '/pages/common/auditCommunityManage',
        name: '/pages/common/auditCommunityManage',
        component: () => import('@/views/common/auditCommunityManage.vue')
    },
    {
        path: '/pages/common/advertVedioView',
        name: '/pages/common/advertVedioView',
        component: () => import('@/views/common/advertVedioView.vue')
    },
    // {
    //     path: '/pages/common/addPurchaseApplyStep',
    //     name: '/pages/common/addPurchaseApplyStep',
    //     component: () => import('@/views/common/addPurchaseApplyStep.vue')
    // },
    // {
    //     path: '/pages/common/addItemOutStep',
    //     name: '/pages/common/addItemOutStep',
    //     component: () => import('@/views/common/addItemOutStep.vue')
    // },
    // {
    //     path: '/pages/common/addComplaintStep',
    //     name: '/pages/common/addComplaintStep',
    //     component: () => import('@/views/common/addComplaintStep.vue')
    // },
    {
        path: '/pages/common/addAuditUserStep',
        name: '/pages/common/addAuditUserStep',
        component: () => import('@/views/common/addAuditUserStep.vue')
    }
]
